<app-page-header title="Rapportdetaljer" icon="description"></app-page-header>
<div [@fadeInOut] class="page-content">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Allmänt">
      <form #form="ngForm" [formGroup]="reportForm" (ngSubmit)="save()" novalidate class="flex-col gap-1em" autocomplete="off">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Verksamhet</mat-label>
                <mat-select formControlName="businessId" required (selectionChange)="businessChanged($event)">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of businesses | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('businessId').hasError('required')) {
                  <mat-error>Verksamhet är obligatorisk</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Rapportnamn</mat-label>
                <input matInput formControlName="name" required />
                @if (getFormControl('name').hasError('required')) {
                  <mat-error>Namn är obligatoriskt</mat-error>
                }
                @if (getFormControl('name').hasError('maxlength')) {
                  <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Verksamhetskategori</mat-label>
                <mat-select formControlName="businessCategoryId" (selectionChange)="businessCategoryChanged($event)" required>
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of businessCategories | async; track entry) {
                    <mat-option [value]="entry.item1" [disabled]="isPreview() && entry.item1 != fixedBusinessCategoryId">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('businessCategoryId').hasError('required')) {
                  <mat-error>Verksamhetskategori är obligatorisk</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Status</mat-label>
                <mat-select formControlName="reportStatusId" required>
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of reportStatuses | async; track entry) {
                    <mat-option [value]="entry.item1" [disabled]="(isNew || isPreview()) && entry.item1 != 1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('reportStatusId').hasError('required')) {
                  <mat-error>Status är obligatorisk</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Ägare</mat-label>
                <mat-select formControlName="ownedBy" required>
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of users | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
                @if (getFormControl('ownedBy').hasError('required')) {
                  <mat-error>Ägare är obligatorisk</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Finansiär</mat-label>
                <mat-select formControlName="financierId">
                  <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
                  @for (entry of financiers | async; track entry) {
                    <mat-option [value]="entry.item1">
                      {{ entry.item2 }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Datum för besök</mat-label>
                <input matInput [matDatepicker]="myDatepicker" formControlName="visitDate" />
                <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #myDatepicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Datum för godkännande</mat-label>
                <input matInput type="date" formControlName="approvalDate" [readonly]="true" />
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Kontakt</mat-label>
                <input matInput formControlName="contactPerson" />
                @if (getFormControl('contactPerson').hasError('maxlength')) {
                  <mat-error>Kontakt kan inte innehålla mer än 200 tecken</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Inledning/Sammanfattning</mat-label>
                <textarea rows="10" matInput formControlName="introduction" ></textarea>
              </mat-form-field>
            </div>
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Nivå</mat-label>
                  <input matInput formControlName="scoreLevelName" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Poäng (%)</mat-label>
                  <input matInput formControlName="scorePercentage" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Poäng</mat-label>
                  <input matInput formControlName="score" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Max poäng</mat-label>
                  <input matInput formControlName="maxScore" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Standarduppfyllelse (%)</mat-label>
                  <input matInput formControlName="standardFulfilledPercentage" [readonly]="true" />
                </mat-form-field>
                <div class="flex-1">
                </div>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Skapad av</mat-label>
                  <input matInput value="{{ createdByName$ | async }}" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Skapad</mat-label>
                  <input matInput formControlName="createdDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            @if (!isNew) {
              <div class="flex-row flex-col-ltmd gap-col-1em">
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad av</mat-label>
                  <input matInput value="{{ changedByName$ | async }}" [readonly]="true" />
                </mat-form-field>
                <mat-form-field class="flex-1">
                  <mat-label>Uppdaterad</mat-label>
                  <input matInput formControlName="updatedDate" [readonly]="true" />
                </mat-form-field>
              </div>
            }
            <div class="flex-row flex-col-ltmd gap-col-1em">
              <mat-form-field class="flex-1">
                <mat-label>Metodversion</mat-label>
                <input matInput value="{{ methodVersionName$ | async }}" [readonly]="true" />
              </mat-form-field>
              <mat-form-field class="flex-1">
                <mat-label>Rapport Id</mat-label>
                <input matInput formControlName="reportId" [readonly]="true" />
              </mat-form-field>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <section class="button-container">
              @if (hasPermissionToChange$ | async) {
                <button type="submit" mat-fab color="primary" matTooltip="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
              }
              <button type="button" mat-fab color="accent" title="{{'commands.Options' | translate }}" [matMenuTriggerFor]="optionsMenu"><mat-icon>menu</mat-icon></button>
              <mat-menu #optionsMenu="matMenu">
                <button type="button" mat-menu-item (click)="cancel()"><mat-icon>arrow_back</mat-icon><span>{{'commands.Cancel' | translate }}</span></button>
                <button type="button" mat-menu-item (click)="gotoSummaryView()"><mat-icon>print</mat-icon><span>{{'commands.Print' | translate }}</span></button>
                <button type="button" mat-menu-item [disabled]="!(reactivatePermission$ | async)" (click)="reactivate()"><mat-icon>restore</mat-icon><span>Återaktivera</span></button>
                @if (hasPermissionToDelete()) {
                  <button type="button" mat-menu-item (click)="delete()"><mat-icon>delete</mat-icon><span>{{'commands.Delete' | translate }}</span></button>
                }
              </mat-menu>
            </section>
          </mat-card-actions>
        </mat-card>
      </form>
    </mat-tab>
    @if (!isNew) {
      <mat-tab label="Aspektgrupper">
        @if (selectedTabIndex==1) {
          <div>
            @if (id) {
              <app-report-aspect-group-list [id]="id" [reportIsDirty]="isDirty()" [dirtyMessage]="getDirtyMessage()" [hasPermissionToChange$]="hasPermissionToChange$" (refreshRequest)="refreshRequested()"></app-report-aspect-group-list>
            }
          </div>
        }
      </mat-tab>
    }
    @if (!isNew) {
      <mat-tab label="Standarder">
        @if (selectedTabIndex==2) {
          <div>
            <!-- Due to rendering problem -->
            @if (id) {
              <app-report-standard-group-list [id]="id" [reportIsDirty]="isDirty()" [dirtyMessage]="getDirtyMessage()" [hasPermissionToChange$]="hasPermissionToChange$" (refreshRequest)="refreshRequested()"></app-report-standard-group-list>
            }
          </div>
        }
      </mat-tab>
    }
    @if (!isNew) {
      <mat-tab label="Minimikrav">
        @if (id) {
          <app-report-requirement-list [id]="id" [hasPermissionToChange$]="hasPermissionToChange$"></app-report-requirement-list>
        }
      </mat-tab>
    }
  </mat-tab-group>

</div>
